module.exports = __webpack_public_path__ + "img/synopsis_004.1319a544.png";